import React from 'react'
import { PMUS } from '../PMUS/PMUS'

export const PMUSNeutral = (props) => {
  return (
    <PMUS {...props}/>   
  )
}
